'use strict';

const $ = jQuery.noConflict();
$(function() {

	const wall = {

		init: function() {
			this.cacheDOM();
			this.bindEvents();
		},

		cacheDOM: function() {
			this.$sections = $('.wall');
		},

		bindEvents: function() {
			const _this = this;

			if (!this.$sections.length) {
				return;
			}

			if ('IntersectionObserver' in window) {
				const observer = new IntersectionObserver(
					function(entries) {
						entries.forEach(function(entry) {
							if (entry.isIntersecting) {
								$(entry.target).addClass('is-visible');
								observer.unobserve(entry.target);
							}
						});
					},
					{threshold: 0.15}
				);

				_this.$sections.each(function() {
					observer.observe(this);
				});
			} else {
				_this.$sections.addClass('is-visible');
			}
		},

	};

	wall.init();
});
